import { create } from 'zustand'
import axios from 'axios'

export const API_SLUG = 'ExternalApiAuditLog'

export interface ExternalApiAuditLog {
  id: number
  endpoint: string
  httpMethod: string
  requestBody: string | null
  responseBody: string | null
  statusCode: number
  status: string
  errorMessage: string | null
  ipAddress: string | null
  userAgent: string | null
  clientId: string | null
  processingTimeMs: number | null
  createdAt: string
}

export interface ExternalApiAuditLogStore {
  data: ExternalApiAuditLog[]
  loading: boolean
  error?: any
  getAll: () => Promise<{ success: boolean; data: any }>
  clearState: () => void
}

export const useExternalApiAuditLogStore = create<ExternalApiAuditLogStore>(set => ({
  data: [],
  loading: false,
  error: undefined,
  getAll: async () => {
    set({ loading: true })
    try {
      const response = await axios.get(`/${API_SLUG}`)
      set({ data: response.data, loading: false })

      return { success: true, data: response.data }
    } catch (error: any) {
      set({ loading: false, error })

      return {
        success: false,
        data: (error?.response?.data?.message ?? '').toString(),
      }
    }
  },
  clearState: () => set({ data: [], loading: false, error: undefined }),
}))
